appSocial.component('percentageBar', {
    templateUrl: 'shared/components/percentage-bar/PercentageBarComponent.html',
    bindings: {
        items: '<',
    },
    controller: class PercentageBarComponent {
        constructor(SocialConstants) {

        }

        $onInit() {
            console.log('init percentage bar')
        }

        $onChanges(changes) {
            console.log('change percentage bar')
        }

        $onDestroy() {
            console.log('destroy percentage bar')
        }

    }
})
